<script setup></script>

<template>
  <div class="contact">
    <h3>Contact 📫</h3>
    <p>Have any questions? Don't hesitate, reach out.</p>
    <p>
      <strong>e: </strong>
      <a href="mailto:ebenhafkamp@gmail.com">ebenhafkamp@gmail.com</a>
      <br />
      <strong>m: </strong><a href="tel:+64 21 112 5824">+64 21 112 5824</a>
    </p>
    <p>
      <strong>
        <a href="https://www.linkedin.com/in/eben-hafkamp-a8548a107/">
          LinkedIn
        </a>
      </strong>
    </p>
    <!-- <form class="contact__form">
      <input type="email" name="email" required />
      <textarea name="message" required></textarea>
    </form> -->
  </div>
</template>

<style lang="scss">
.contact {
  margin-block: 3rem;

  &__form {
  }

  p {
    font-family: monospace;
    color: var(--white);
  }
}
</style>
